import MyNavbar from '../../../components/Customer/Mynavbar/MyNavbar';
import Footer from '../../../components/Customer/Footer/Footer';
import TestimonialsSection from './subscreens/TestimonialsSection/TestimonialsSection';
import Carousel from './subscreens/Carousel/Carousel';
import SectionHero from './SectionHero/SectionHero';
import ProductCard from '../../../components/Customer/ProductCard/ProductCard';
import ContactForm from './ContactForm/ContactForm';
import Customize from '../Customize/Customize';
import '../../../assests/css/customer/Home/Home.css';
import SalePageForCustomer from '../../../subscreens/Home/SalePageForCustomer/SalePageForCustomer';
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import AppContext from '../../../context/AppContext';

const Home = () => {
  const { baseUrl } = useContext(AppContext);

  const [wishlist, setWishlist] = useState([]);
  const [cart, setCart] = useState([]);
  const [tryOnProducts, setTryOnProducts] = useState([]);
  const [customizeProducts, setCustomizeProducts] = useState([]);
  const [loadingTryOn, setLoadingTryOn] = useState(true);
  const [loadingCustomize, setLoadingCustomize] = useState(true);

  
  useEffect(() => {
axios.get(`${baseUrl}/products/home?type=stitched`)
      .then((res) => {
        if (res.data.success) setTryOnProducts(res.data.products);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoadingTryOn(false));
  }, []);


  useEffect(() => {
axios.get(`${baseUrl}/products/home?type=unstitched`)   
   .then((res) => {
        if (res.data.success) setCustomizeProducts(res.data.products);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoadingCustomize(false));
  }, []);

  const toggleWishlist = (productId) => {
    setWishlist((prev) =>
      prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId]
    );
  };

  const toggleCart = (productId, cartId) => {
    setCart((prev) => {
      const exists = prev.some((item) => item.Mlproduct_id === productId);
      if (exists) {
        return prev.filter((item) => item.Mlproduct_id !== productId);
      } else {
        return [...prev, { Mlproduct_id: productId, id: cartId }];
      }
    });
  };

  return (
    <>
      <MyNavbar />
      <br />
      <br />
      <br />
      {/* <SalePageForCustomer /> */}
      <SectionHero />
      <Carousel />

      {/* ✅ Try On Section */}
      <section className="home-products-section">
        <div className="home-products-container">
          <h2 className="home-products-title">Try On Our Collection</h2>
          {loadingTryOn ? (
            <p style={{ textAlign: 'center', padding: '40px' }}>Loading...</p>
          ) : tryOnProducts.length === 0 ? (
            <p style={{ textAlign: 'center', padding: '40px' }}>No products found.</p>
          ) : (
            <div className="home-products-grid">
              {tryOnProducts.map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  type={product.type}
                  wishlist={wishlist}
                  toggleWishlist={toggleWishlist}
                  cart={cart}
                  toggleCart={toggleCart}
                />
              ))}
            </div>
          )}
        </div>
      </section>

      <SalePageForCustomer />
      <Customize />

      {/* ✅ Customize Section */}
      <section className="home-products-section">
        <div className="home-products-container">
          <h2 className="home-products-title">Customize Your Style</h2>
          {loadingCustomize ? (
            <p style={{ textAlign: 'center', padding: '40px' }}>Loading...</p>
          ) : customizeProducts.length === 0 ? (
            <p style={{ textAlign: 'center', padding: '40px' }}>No products found.</p>
          ) : (
            <div className="home-products-grid">
              {customizeProducts.map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  type={product.type}
                  wishlist={wishlist}
                  toggleWishlist={toggleWishlist}
                  cart={cart}
                  toggleCart={toggleCart}
                />
              ))}
            </div>
          )}
        </div>
      </section>

      <TestimonialsSection />
      <ContactForm />
      <Footer />
    </>
  );
};

export default Home;